import React, { useEffect, useLayoutEffect, useState } from "react";
import ReactPlayer from "react-player";
import { getCaptionUrl } from "../../utils";
import "./VideoPlayer.scss";

function VideoPlayer({
  playerRef,
  url,
  muted,
  playing,
  volume,
  onProgress,
  onDuration,
  onEnded,
  onStart,
  onReady,
  onPlay,
  onPause,
  onError,
  onBufferEnd,
  controls = false,
  caption,
}) {
  const updateCue = () => {
    // const tracks = document.getElementsByTagName('track');
    // if (tracks?.length) {
    //   // Move the cue up 5 lines to make room for video controls
    //   const cues = tracks[0].track.activeCues;
    //   if (cues?.length) {
    //     cues[0].line = -5;
    //   }
    // }
  };

  return (
    <ReactPlayer
      ref={playerRef}
      url={url}
      style={{
        position: "absolute",
        top: 0,
        zIndex: 1,
      }}
      volume={volume !== undefined ? volume : 0.8}
      muted={muted}
      width={"100%"}
      height={"100%"}
      playing={playing}
      playsinline
      onEnded={() => {
        onEnded();
      }}
      onPause={() => {
        onPause();
      }}
      onError={(e) => {
        onError(e);
      }}
      onReady={(player) => {
        onReady();
      }}
      onStart={() => {
        onStart();
      }}
      onDuration={(e) => {
        onDuration(e);
      }}
      onBufferEnd={() => {
        onBufferEnd();
      }}
      onPlay={() => {
        onPlay();
      }}
      onProgress={({ played, playedSeconds, loaded, loadedSeconds }) => {
        // console.log(`Player on progress ${played} ${playedSeconds} ${loaded} ${loadedSeconds}`);
        onProgress(played, playedSeconds);
        updateCue();
      }}
      progressInterval={100}
      config={{
        youtube: {
          playerVars: {
            disablekb: 1,
            showinfo: 0,
            rel: 0,
          },
        },
        file: {
          tracks: [
            {
              kind: "captions",
              src: getCaptionUrl(caption),
              srcLang: "en",
              default: true,
              mode: "showing",
            },
          ],
        },
      }}
      controls={false}
    ></ReactPlayer>
  );
}

VideoPlayer.defaultProps = {
  onEnded: () => {},
  onError: () => {},
  onReady: () => {},
  onStart: () => {},
  onPlay: () => {},
  onBufferEnd: () => {},
  onPause: () => {},
};

export default VideoPlayer;
